module.exports = __webpack_public_path__ + "images/bug_green_size_4_638044c1b298fdefab2d15ed7dea736b.png";